import { render, staticRenderFns } from "./RecentActivityTableDescriptionSubscriptionCancelled.vue?vue&type=template&id=0cd496cf&"
import script from "./RecentActivityTableDescriptionSubscriptionCancelled.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionSubscriptionCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports